<ng-container *transloco="let convert;">
  <div class="dealer-seller">

    <div class="posting-criteria">
      <h2 data-test-id="dealer-seller-posting-criteria-heading" class="focus-outline-none posting-criteria__title bold-title" tabindex="-1" #pageHeading>
        {{convert('profileManagement.dealerSeller.postingCriteriaPageHeader')}}
      </h2>
      @if (!isEligibleToPost) {
        <div data-test-id="dealer-seller-ineligible-message">{{convert('profileManagement.dealerSeller.ineligibleToPost')}}</div>
      }
      @if (isEligibleToPost) {
        <app-legacy-table data-test-id="dealer-seller-posting-criteria-table" [columns]="postingColumns" [data]="postingData"
          [tenantName]="tenantName$ | async" [cardConfig]="cardConfig"
          [caption]="convert('profileManagement.dealerSeller.captionPostingCriteria')"
          >
          <table-row-group>
            <table-row [columns]="postingColumns" [row]="postingData?.postingCriteria">
              <table-cell *appTableCell="let row; column: 'postingEligibility'">{{ row?.postingEligibility }}</table-cell>
              <table-cell *appTableCell="let row; column: 'dailyPostingLimit'">{{ row?.dailyPostingLimit }}</table-cell>
              <table-cell *appTableCell="let row; column: 'optInPmAuction'">{{ row?.optInPmAuction }}</table-cell>
              <table-cell *appTableCell="let row; column: 'acceptingOffers'">{{ row?.acceptingOffers }}</table-cell>
              <table-cell *appTableCell="let row; column: 'acceptingQuestions'">{{ row?.acceptingQuestions }}</table-cell>
              <table-cell *appTableCell="let row; column: 'postSettings'">
                <button
                  data-test-id="dealer-seller-posting-criteria-edit-button"
                  data-track-elem="button"
                  data-track-name="Edit"
                  class="btn btn-link p-0"
                  (click)="sellerDrawer.open(); updateForm()"
                  [attr.aria-label]="convert('profileManagement.dealerSeller.editPostingSettings')"
                  id="edit-criteria"
                  >
                  {{convert('profileManagement.dealercontact.edit')}}
                </button>
              </table-cell>
            </table-row>
            <table-row [row]="postingData?.postingCriteria" [expandable]="true" #sellerDrawer="table-row">
              <table-cell *appTableCell="let row; colSpan: postingColumns.length">
                <div class="container drawer">
                  <h3 data-test-id="dealer-seller-post-settings-heading" tabindex="-1" class="focus-outline-none" id="seller_header">{{convert('profileManagement.dealerSeller.postSettings')}}</h3>
                  <p data-test-id="dealer-seller-post-settings-description">
                    {{convert('profileManagement.dealerSeller.selectFeatures')}}
                  </p>
                  <form
                    data-test-id="dealer-seller-post-settings-form"
                    name="form"
                    class="form"
                    [formGroup]="dealerSellerForm"
                    >
                    <div class="d-flex flex-row align-bottom">
                      <div class="d-flex flex-column">
                        <div class="p-2">
                          <label data-test-id="dealer-seller-pm-auction-label" for="pm_auction" id="pm_auction-label">{{convert('profileManagement.dealerSeller.optIntoPMAuction')}}</label>
                        </div>
                        <div class="p-2">
                          <label data-test-id="dealer-seller-accept-offers-label" for="accept_offers" id="accept_offers-label">{{convert('profileManagement.dealerSeller.acceptOffers')}}</label>
                        </div>
                        <div class="p-2">
                          <label data-test-id="dealer-seller-accept-questions-label" for="accept_questions" id="accept_questions-label">{{convert('profileManagement.dealerSeller.acceptQuestions')}}</label>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div class="p-2">
                          <mat-slide-toggle data-test-id="dealer-seller-pm-auction-toggle" #pmAuctionToggle id="pm_auction" (change)="updateToggle($event, 'optInPmAuction')"
                          color="primary" class="mat-toggle" formControlName="pmToggleFC" aria-required="true" aria-labelledby="pm_auction-label"></mat-slide-toggle>
                        </div>
                        <div class="p-2">
                          <mat-slide-toggle data-test-id="dealer-seller-accept-offers-toggle" #offersToggle id="accept_offers" (change)="updateToggle($event, 'acceptingOffers')"
                          color="primary" class="mat-toggle" formControlName="offerToggleFC" aria-required="true" aria-labelledby="accept_offers-label"></mat-slide-toggle>
                        </div>
                        <div class="p-2">
                          <mat-slide-toggle data-test-id="dealer-seller-accept-questions-toggle" #questionsToggle id="accept_questions" (change)="updateToggle($event, 'acceptingQuestions')"
                          color="primary" class="mat-toggle" formControlName="questionToggleFC" aria-required="true" aria-labelledby="accept_questions-label"></mat-slide-toggle>
                        </div>
                      </div>
                    </div>
                  </form>
                  <button
                    data-test-id="dealer-seller-post-settings-close-button"
                    data-track-elem="icon"
                    data-track-name="Close"
                    data-track-trigger="close"
                    class="drawer__close"
                    [attr.aria-label]="convert('common.btnClose')"
                    (click)="sellerDrawer.close()"
                    >
                    <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
                  </button>
                </div>
              </table-cell>
            </table-row>
          </table-row-group>
        </app-legacy-table>
      }
    </div>
    <div class="seller-fees">
      @if (isEligibleToPost) {
        <h2 data-test-id="dealer-seller-fees-heading" class="focus-outline-none seller-fees__title bold-title" tabindex="-1" #pageHeading>
          {{convert('profileManagement.dealerSeller.sellerFeesPageHeader')}}
        </h2>
      }
      @if (isEligibleToPost) {
        <app-legacy-table data-test-id="dealer-seller-fees-table" [columns]="feeColumns" [data]="feeTypes"
          [tenantName]="tenantName$ | async" id="dealer-seller-fees-table" [cardConfig]="cardConfig"
          [caption]="convert('profileManagement.dealerSeller.captionSellerFees')">
          @for (row of feeTypes; track row; let i = $index) {
            <table-row [attr.data-test-id]="'dealer-seller-fees-row-' + i" [columns]="feeColumns" [row]="row">
              <table-cell *appTableCell="let row; column: 'feeName'">{{ row.feeType }}</table-cell>
              <table-cell *appTableCell="let row; column: 'standard'">{{ row.feeAmount | currency: 'USD':'symbol':'1.0-2' }}</table-cell>
            </table-row>
          }
        </app-legacy-table>
      }
    </div>
  </div>
</ng-container>
